/**
 * `/modules.json` — the import map the CURRENT deploy is serving, as a file (D118, PNK-121).
 *
 * The map itself is baked into the bundle (`importMap.ts`), which is right for booting and useless
 * for one question: *has the deploy moved on since this tab loaded?* A tab can only answer that by
 * asking something outside itself, and until D118 it asked `GET /tenant-apps/resolve`.
 *
 * So `apps/shell/vite.config.ts` emits the same derived map as a static asset, and
 * `docker/shell/nginx.conf.template` serves it `no-cache` exactly as it serves `index.html` — for
 * the same reason: both name content-hashed or versioned files, so a stale copy pins a browser to a
 * deleted build. `spa/registry.ts` is the only reader, on the 404 path only.
 *
 * It is NOT what the shell boots from. A boot that fetched this would reintroduce the network wait
 * D118 removed, and it would be the wrong value besides: the running bundle must load the modules it
 * was built against, not the ones a deploy mid-flight is publishing.
 */
export const MODULE_MAP_URL = "/modules.json";
